var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-head"},[_c('div',{staticClass:"logos"},[_c('Logo'),_c('Hacienda')],1),_c('div',{staticClass:"middle"},[_c('RedesSociales'),_c('LogOut')],1),_c('div',{staticClass:"menu"},[_c('Menu')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }